import React, { useState } from "react";
import { Col, Container, Row, Tab, Form } from "@themesberg/react-bootstrap";
import Select from "react-select";

import AllBackOfficeEntry from "./AllBackOfficeEntry";
import AllCustomerEntry from "./AllCustomerEntry";
import AllDealerEntry from "./AllDealerEntry";
import AllServiceEntry from "./AllServiceEntry";
import AllnontechEntry from "./AllnontechEntry";
import AllTechechEntry from "./AllTechechEntry";
import AllRoManagerEntry from "./AllRoManagerEntry";
import AllSalesEntry from "./AllSalesEntry";
import AllRNDEntry from "./AllRNDEntry";
import AllSLTEntry from "./AllSLTEntry";
import AllProcruemntEntry from "./AllProcruemntEntry";
import AllFinanceEntry from "./AllFInanceEntry";
import AllProductionEntry from "./AllProductionEntry";
import AllEmpEntry from "./AllEmpEntry";
import AllManagerEntry from "./AllManagerEntry";

export default () => {
  const [activeRole, setActiveRole] = useState("backoffice");

  const roleOptions = [
    { value: "backoffice", label: "BackOffice User View" },
    { value: "serviceengineer", label: "Service Engineer View" },
    { value: "customer", label: "Customer User View" },
    { value: "nontech person", label: "Non Tech User view" },
    { value: "tech person", label: "Tech User view" },
    { value: "romanager", label: "Ro Manager view" },
    { value: "dealer", label: "Dealer User View" },
    { value: "sales", label: "Sales User View" },
    { value: "rnd_reviewer", label: "RND Reviewer View" },
    { value: "slt_reviewer", label: "SLT Reviewer View" },
    { value: "procurement_reviewer", label: "Procurement Reviewer View" },
    { value: "finance_reviewer", label: "Finance Reviewer View" },
    { value: "production_reviewer", label: "Production Reviewer View" },
    { value: "Employee", label: "Employee User View" },
    { value: "Manager", label: "Manager User View" }
  ];

  return (
    <article>
      <Container className="px-0">
        <Row className="d-flex flex-wrap flex-md-nowrap align-items-center py-4">
          <Col className="d-block mb-2 mb-md-0">
            <h5 className="head mb-0">User Access Control</h5>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={6} lg={4}>
            <Form.Group>
              <Form.Label className="fw-bold text-muted mb-1">Select Role Wise User</Form.Label>
              <Select 
                options={roleOptions}
                value={roleOptions.find(opt => opt.value === activeRole)}
                onChange={(selectedOption) => setActiveRole(selectedOption.value)}
                maxMenuHeight={220}
                className="react-select-container shadow-sm fw-bold border-success border-2 rounded"
                classNamePrefix="react-select"
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: '#198754',
                    borderWidth: '2px',
                    boxShadow: 'none',
                    '&:hover': { borderColor: '#198754' }
                  })
                }}
              />
            </Form.Group>
          </Col>
        </Row>

        <div className="bg-white rounded shadow-sm border p-3">
          <Tab.Container activeKey={activeRole}>
            <Tab.Content>
              <Tab.Pane eventKey="backoffice" className="py-2">
                <AllBackOfficeEntry />
              </Tab.Pane>
              <Tab.Pane eventKey="serviceengineer" className="py-2">
                <AllServiceEntry />
              </Tab.Pane>
              <Tab.Pane eventKey="dealer" className="py-2">
                <AllDealerEntry />
              </Tab.Pane>
              <Tab.Pane eventKey="customer" className="py-2">
                <AllCustomerEntry />
              </Tab.Pane>
              <Tab.Pane eventKey="nontech person" className="py-2">
                <AllnontechEntry />
              </Tab.Pane>
              <Tab.Pane eventKey="tech person" className="py-2">
                <AllTechechEntry />
              </Tab.Pane>
              <Tab.Pane eventKey="romanager" className="py-2">
                <AllRoManagerEntry/>
              </Tab.Pane>
              <Tab.Pane eventKey="sales" className="py-2">
                <AllSalesEntry/>
              </Tab.Pane>
              <Tab.Pane eventKey="rnd_reviewer" className="py-2">
                <AllRNDEntry/>
              </Tab.Pane>
              <Tab.Pane eventKey="slt_reviewer" className="py-2">
                <AllSLTEntry/>
              </Tab.Pane>
              <Tab.Pane eventKey="procurement_reviewer" className="py-2">
                <AllProcruemntEntry/>
              </Tab.Pane>
              <Tab.Pane eventKey="finance_reviewer" className="py-2">
                <AllFinanceEntry/>
              </Tab.Pane>
              <Tab.Pane eventKey="production_reviewer" className="py-2">
                <AllProductionEntry/>
              </Tab.Pane>
              <Tab.Pane eventKey="Employee" className="py-2">
                <AllEmpEntry />
              </Tab.Pane>
              <Tab.Pane eventKey="Manager" className="py-2">
                <AllManagerEntry />
              </Tab.Pane>
            </Tab.Content>
            
          </Tab.Container>
        </div>
      </Container>
    </article>
  );
};
